import { Box, Typography } from "@mui/joy";
import { CERTIFICATIONS } from "../data/products";

export function CertMarquee({ dark = false }) {
  const items = [...CERTIFICATIONS, ...CERTIFICATIONS];

  return (
    <Box
      data-testid="cert-marquee"
      sx={{
        py: 3,
        borderTop: "1px solid",
        borderBottom: "1px solid",
        backgroundColor: dark ? "#111111" : "#1A1A1A",
        borderColor: dark ? "rgba(255,255,255,0.1)" : "#1A1A1A",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          animation: "certMarquee 35s linear infinite",
          willChange: "transform",
          "@keyframes certMarquee": {
            from: {
              transform: "translateX(0)",
            },
            to: {
              transform: "translateX(-50%)",
            },
          },
        }}
      >
        {items.map((c, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                px: 4,
                fontFamily: '"Clash Display", sans-serif',
                fontWeight: 700,
                fontSize: {
                  xs: "1.25rem",
                  md: "1.5rem",
                },
                color: "rgba(255,255,255,0.9)",
                textTransform: "uppercase",
                letterSpacing: "-0.02em",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
              }}
            >
              {c}
            </Typography>

            <Typography
              component="span"
              sx={{
                color: "#D32F2F",
                fontSize: "1.5rem",
                lineHeight: 1,
                mx: 1,
              }}
            >
              ✦
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
